import { ThemeProps as Prop, ColorProfiles, Components } from '@powdr/constants';

export const woodwardTheme = {
  [ColorProfiles.BASE]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.HEADER]: '#000000',
    [Prop.CONTENT]: '#000000',
    [Prop.LINK_TXT]: '#000000',
    [Prop.LINK_TXT_HOVER]: '#ffd200',
    [Prop.BTN_BG]: '#ffd200',
    [Prop.BTN_TXT]: '#000000',
    [Prop.BTN_BG_HOVER]: '#000000',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#000000',
    [Prop.BTN_TXT_ACTIVE]: '#ffd200',
    [Prop.BTN_BG_INACTIVE]: '#b4b4b4',
    [Prop.BTN_TXT_INACTIVE]: '#FFFFFF',
    [Prop.ELEMENT]: '#000000',
    [Prop.ELEMENT_TXT]: '#000000',
    [Prop.BORDER]: '#e0e0e0',
    [Prop.ICON]: '#ffd200',
    [Prop.ICON_HOVER]: '#000000',
  },
  [ColorProfiles.PRIMARY]: {
    [Prop.BACKGROUND]: '#3a3a3a',
    [Prop.HEADER]: '#ffd200',
    [Prop.CONTENT]: '#ffffff',
    [Prop.LINK_TXT]: '#ffd200',
    [Prop.LINK_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG]: '#ffd200',
    [Prop.BTN_TXT]: '#000000',
    [Prop.BTN_BG_HOVER]: '#000000',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#000000',
    [Prop.BTN_TXT_ACTIVE]: '#ffffff',
    [Prop.BTN_BG_INACTIVE]: '#757575',
    [Prop.BTN_TXT_INACTIVE]: '#ffd200',
    [Prop.ELEMENT]: '#ffffff',
    [Prop.ELEMENT_TXT]: '#000000',
    [Prop.BORDER]: '#696969',
    [Prop.ICON]: '#ffffff',
    [Prop.ICON_HOVER]: '#ffd200',
  },
  [ColorProfiles.SECONDARY]: {
    [Prop.BACKGROUND]: '#000000',
    [Prop.HEADER]: '#ffd200',
    [Prop.CONTENT]: '#ffffff',
    [Prop.LINK_TXT]: '#ffffff',
    [Prop.LINK_TXT_HOVER]: '#ffd200',
    [Prop.BTN_BG]: '#ffd200',
    [Prop.BTN_TXT]: '#000000',
    [Prop.BTN_BG_HOVER]: '#ffd200',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#ffffff',
    [Prop.BTN_TXT_ACTIVE]: '#000000',
    [Prop.BTN_BG_INACTIVE]: '#4d4d4d',
    [Prop.BTN_TXT_INACTIVE]: '#ffffff',
    [Prop.ELEMENT]: '#ffd200',
    [Prop.ELEMENT_TXT]: '#000000',
    [Prop.BORDER]: '#ffd200',
    [Prop.ICON]: '#ffffff',
    [Prop.ICON_HOVER]: '#ffd200',
  },
  [ColorProfiles.TERTIARY]: {
    [Prop.BACKGROUND]: '#3a3a3a',
    [Prop.HEADER]: '#ffd200',
    [Prop.CONTENT]: '#ffffff',
    [Prop.LINK_TXT]: '#ffd200',
    [Prop.LINK_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG]: '#ffd200',
    [Prop.BTN_TXT]: '#000000',
    [Prop.BTN_BG_HOVER]: '#000000',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.BTN_BG_ACTIVE]: '#000000',
    [Prop.BTN_TXT_ACTIVE]: '#ffffff',
    [Prop.BTN_BG_INACTIVE]: '#757575',
    [Prop.BTN_TXT_INACTIVE]: '#ffd200',
    [Prop.ELEMENT]: '#ffffff',
    [Prop.ELEMENT_TXT]: '#000000',
    [Prop.BORDER]: '#696969',
    [Prop.ICON]: '#ffffff',
    [Prop.ICON_HOVER]: '#ffd200',
  },
  [ColorProfiles.QUATERNARY]: {
    [Prop.BACKGROUND]: '#ffd200',
    [Prop.HEADER]: '#000000',
    [Prop.CONTENT]: '#000000',
    [Prop.LINK_TXT]: '#000000',
    [Prop.LINK_TXT_HOVER]: '#666666',
    [Prop.BTN_BG]: '#000000',
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_BG_HOVER]: '#000000',
    [Prop.BTN_TXT_HOVER]: '#FFD200',
    [Prop.BTN_BG_ACTIVE]: '#ffffff',
    [Prop.BTN_TXT_ACTIVE]: '#ffd200',
    [Prop.BTN_BG_INACTIVE]: '#A29B6B',
    [Prop.BTN_TXT_INACTIVE]: '#ffd200',
    [Prop.ELEMENT]: '#000000',
    [Prop.ELEMENT_TXT]: '#000000',
    [Prop.BORDER]: '#000000',
    [Prop.ICON]: '#000000',
    [Prop.ICON_HOVER]: '#FFFFFF',
  },
  [Components.DOR_LIFTS_TRAILS]: {
    [Prop.ICON_2]: '#ffd200',
    [Prop.ICON_HOVER_2]: '#000000',
    [Prop.HEADER_BG]: '#ffd200',
    [Prop.HEADER_TXT]: '#000000',
    [Prop.HEADER_ICON]: '#FFFFFF',
    [Prop.HEADER_BG_2]: '#000000',
    [Prop.HEADER_TXT_2]: '#ffd200',
    [Prop.HEADER_ICON_2]: '#FFFFFF',
    [Prop.TABLE_HEADER_BG]: '#b3b3b3',
    [Prop.TABLE_HEADER_TXT]: '#3F3F3F',
    [Prop.ODD_EVEN_OFFSET]: '#e0e0e0',
  },
};

export const componentThemesDefault = {
  [Components.DOR_LIFTS_TRAILS]: {
    [Prop.ICON_2]: '#D4441C',
    [Prop.ICON_HOVER_2]: '#D4441C',
    [Prop.HEADER_BG]: '#000000',
    [Prop.HEADER_TXT]: '#ffffff',
    [Prop.HEADER_ICON]: '#D4441C',
    [Prop.HEADER_BG_2]: '#D4441C',
    [Prop.HEADER_TXT_2]: '#ffffff',
    [Prop.HEADER_ICON_2]: '#ffffff',
    [Prop.TABLE_HEADER_BG]: '#b3b3b3',
    [Prop.TABLE_HEADER_TXT]: '#3F3F3F',
    [Prop.ODD_EVEN_OFFSET]: '#E5EDED',
  },

  // required for WW theme takeover
  [Components.ALERT_BAR]: {
    [Prop.BACKGROUND]: '#234c5b',
    [Prop.HEADER]: '#FFFFFF',
    [Prop.CONTENT]: '#FFFFFF',
    [Prop.LINK_TXT]: '#14CAD3',
    [Prop.LINK_TXT_HOVER]: '#E9792C',
    [Prop.BTN_BG]: '#D4441C',
    [Prop.BTN_TXT]: '#ffffff',
    [Prop.BTN_BG_HOVER]: '#E9792C',
    [Prop.BTN_TXT_HOVER]: '#ffffff',
    [Prop.ICON]: '#00818F',
    [Prop.ICON_HOVER]: '#14CAD3',
  },

  // required for WW theme takeover
  [Components.HEADER]: {
    [Prop.LOGO_BG]: '#D4441C',
    [Prop.NAV_BG]: '#FFFFFF',
    [Prop.NAV_ITEM_TXT_TRANSLUCENT]: '#FFFFFF',
    [Prop.NAV_ITEM_TXT_SOLID]: '#4D5859',
    [Prop.NAV_ITEM_TXT_ACTIVE]: '#FFFFFF',
    [Prop.NAV_ITEM_BG_ACTIVE]: '#00AEBB',
    [Prop.NAV_ITEM_ACTIVE_ACCENT]: '#00AEBB',
    [Prop.WW_ICON_COLOR]: '#FFD200',
  },

  // required for WW theme takeover
  [Components.WEATHER_FEED]: {
    [Prop.BACKGROUND]: '#00818F',
    [Prop.ICON]: '#234c5b',
    [Prop.CONTENT]: '#FFFFFF',
  },

  // required for WW theme takeover
  [Components.DOR]: {
    [Prop.ICON]: '#234c5b',
    [Prop.LINK_TXT]: '#D4441C',
    [Prop.LINK_TXT_HOVER]: '#00818F',
    [Prop.BORDER]: '#234c5b',
    [Prop.COMPONENT_BORDER]: '#C4C4C4',
  },

  // required for WW theme takeover
  [Components.PROMOTIONS_FEED]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.LINK_TXT]: '#D4441C',
  },

  [Components.PROMOTIONS]: {
    [Prop.PROMO_ITEM_BG]: '#00818F',
    [Prop.PROMO_ITEM_HEADER]: '#FFFFFF',
    [Prop.PROMO_ITEM_CONTENT]: '#FFFFFF',
    [Prop.PROMO_ITEM_BTN_BG]: '#D4441C',
    [Prop.PROMO_ITEM_BTN_TXT]: '#FFFFFF',
    [Prop.PROMO_ITEM_BTN_BG_HOVER]: '#E9792C',
    [Prop.PROMO_ITEM_BTN_TXT_HOVER]: '#FFFFFF',
  },

  // required for WW theme takeover
  [Components.MEGA_NAV]: {
    [Prop.LINK_TXT]: '#2F3738',
    [Prop.LINK_TXT_HOVER]: '#D4441C',
    [Prop.BORDER]: '#C4C4C4',
  },

  // required for WW theme takeover
  [Components.ECOMMERCE_BANNER]: {
    [Prop.BACKGROUND]: '#234c5b',
    [Prop.LINK_TXT]: '#14CAD3',
    [Prop.LINK_TXT_HOVER]: '#E9792C',
    [Prop.TOGGLE_ACTIVE]: '#C4C4BF',
    [Prop.TOGGLE_INACTIVE]: '#C4C4BF',
    [Prop.ELEMENT]: '#00818f',
    [Prop.LINK_SEPARATOR]: '#5a5b5c',
  },

  // required for WW theme takeover
  [Components.MOBILE_NAV]: {
    [Prop.MENU_BTN_BG]: '#FFFFFF',
    [Prop.MENU_BTN_ICON]: '#00818F',
    [Prop.LOGO_BG]: '#2F3738',
    [Prop.CLOSE_BTN_BG]: '#D4441C',
    [Prop.CLOSE_BTN_ICON]: '#FFFFFF',
    [Prop.MAIN_NAV_BG]: '#2F3738',
    [Prop.MAIN_NAV_TXT]: '#FFFFFF',
    [Prop.MAIN_NAV_BORDER]: '#586161',
    [Prop.WW_ICON_COLOR]: '#FFD200',
    [Prop.DRAWER_BTN_BG]: '#2F3738',
    [Prop.DRAWER_BTN_TXT]: '#D4441C',
    [Prop.PROMO_BTN_BG]: '#FFFFFF',
    [Prop.PROMO_BTN_TXT]: '#D4441C',
    [Prop.SUB_NAV_BG]: '#D4441C',
    [Prop.SUB_NAV_TXT]: '#FFFFFF',
    [Prop.SUB_NAV_BORDER]: '#586161',
  },

  // required for WW theme takeover
  [Components.FOOTER]: {
    [Prop.BACKGROUND]: '#234c5b',
    [Prop.HEADER]: '#FFFFFF',
    [Prop.BTN_BG]: '#D4441C',
    [Prop.BTN_TXT]: '#FFFFFF',
    [Prop.BTN_BG_HOVER]: '#E9792C',
    [Prop.BTN_TXT_HOVER]: '#FFFFFF',
  },

  // required for WW theme takeover
  [Components.FOOTER_NAV]: {
    [Prop.LINK_TXT]: '#D4441C',
    [Prop.LINK_TXT_HOVER]: '#E9792C',
  },

  // required for WW theme takeover
  [Components.COPYRIGHT]: {
    [Prop.BACKGROUND]: '#00818f',
    [Prop.LINK_TXT]: '#234c5b',
  },

  [Components.NAVIGATION_TOGGLE]: {
    [Prop.NAV_TOGGLE_TXT]: '#D4441C',
    [Prop.NAV_TOGGLE_ICON]: '#D4441C',
    [Prop.NAV_TOGGLE_TXT_SCROLLED]: '#D4441C',
    [Prop.NAV_TOGGLE_ICON_SCROLLED]: '#D4441C',
  },
};
